angular.module('shbdeployer.integrations.storidge').controller('StoridgeNodeController', [
  '$scope',
  '$state',
  '$transition$',
  'Notifications',
  'StoridgeNodeService',
  'ModalService',
  function ($scope, $state, $transition$, Notifications, StoridgeNodeService, ModalService) {
    $scope.removeNodeAction = function (selectedItems) {
      ModalService.confirm({
        title: 'Вы уверены?',
        message: 'Удалить узел из кластера?',
        buttons: {
          confirm: {
            label: 'Удалить',
            className: 'btn-danger',
          },
        },
        callback: function onConfirm(confirmed) {
          if (!confirmed) {
            return;
          }
          remove(selectedItems);
        },
      });
    };

    function remove() {
      StoridgeNodeService.remove($scope.node.Name)
        .then(function success() {
          Notifications.success('Узел успешно удален', $scope.node.Name);
          $state.go('storidge.cluster');
        })
        .catch(function error(err) {
          Notifications.error('Ошибка', err, 'Не удалось удалить узел');
        });
    }

    $scope.cordonNodeAction = function (selectedItems) {
      ModalService.confirm({
        title: 'Вы уверены?',
        message: 'Перевести узел в режим обслуживания?',
        buttons: {
          confirm: {
            label: 'Перевести в обслуживание',
            className: 'btn-danger',
          },
        },
        callback: function onConfirm(confirmed) {
          if (!confirmed) {
            return;
          }
          cordonNode(selectedItems);
        },
      });
    };

    function cordonNode() {
      StoridgeNodeService.cordon($scope.node.Name)
        .then(function success() {
          Notifications.success('Узел переведен в режим обслуживания');
        })
        .catch(function error(err) {
          Notifications.error('Ошибка', err, 'Не удалось перевести узел в режим обслуживания');
        })
        .finally(function final() {
          $state.reload();
        });
    }

    $scope.uncordonNodeAction = function (selectedItems) {
      ModalService.confirm({
        title: 'Вы уверены?',
        message: 'Вывести узлы из режима обслуживания?',
        buttons: {
          confirm: {
            label: 'Вывести из обслуживания',
            className: 'btn-danger',
          },
        },
        callback: function onConfirm(confirmed) {
          if (!confirmed) {
            return;
          }
          uncordonNode(selectedItems);
        },
      });
    };

    function uncordonNode() {
      StoridgeNodeService.uncordon($scope.node.Name)
        .then(function success() {
          Notifications.success('Узел выведен из режима обслуживания');
        })
        .catch(function error(err) {
          Notifications.error('Ошибка', err, 'Не удалось вывести узел из режима обслуживания');
        })
        .finally(function final() {
          $state.reload();
        });
    }

    function initView() {
      $scope.name = $transition$.params().name;

      StoridgeNodeService.node($scope.name)
        .then(function success(data) {
          $scope.node = data;
        })
        .catch(function error(err) {
          Notifications.error('Ошибка', err, 'Не удалось получить сведения об узле');
        });
    }

    initView();
  },
]);
